import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=382936bc&"
import script from "./Sport.vue?vue&type=script&lang=js&"
export * from "./Sport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports